export default __webpack_public_path__ + "static/media/7.f627bf81.PNG";